<!-- Dynamically Add Blocks here -->
<!-- This Blocks List Is For JQuery Reference. Do Not Remove! -->
<div cdkDropList (cdkDropListDropped)="onDropCDKBlock($event)">
    <div cdkDrag *ngFor="let block of newsletterSectionBlocks" [ngSwitch]="block?.section_type">
      <div class="cms-default-blocks" id="{{block.section_id}}">
        <div class="cms-block cms-block-heading1 cms-editable-area clearfix" *ngSwitchCase="'nl_heading'">

          <div class="cms-control-button block-move">
            <a title="Move this Block">
              <span>move</span>
            </a>
          </div>
          <div class="cms-control-button block-move-up" style="float: left;">
            <a title="Move this Block up" (click)="moveUp(block)">
              <span>up</span>
            </a>
          </div>
          <div class="cms-control-button block-move-down" style="float: left;">
            <a title="Move this Block down" (click)="moveDown(block)">
              <span>down</span>
            </a>
          </div>
          <div class="cms-control-button block-delete">
            <!-- <a title="Delete this Block" (click)="deleteBlock(block)">
              <span>delete</span>
            </a> -->
            <span class="basic-icon delete-icon center-text"
              style="width: 23px; height: 23px; transform: translate(-50%, 23%);"
              (click)="deleteBlock(block)"></span>
          </div>
          <h3 class="cms-editable-element" [class.heading-background]="block?.content" (click)="editHeading(block)">
            {{block?.content?block?.content:"Heading"}}
          </h3>
        </div>
        <!-- cms-block-heading end -->
        <div id="{{block.section_id}}" class="cms-block cms-block-products1 cms-editable-area clearfix" *ngSwitchCase="'products'">
          <div class="cms-control-button block-move">
            <a title="Move this Block">
              <span>move</span>
            </a>
          </div>
          <div class="cms-control-button block-move-up" style="float: left;">
            <a title="Move this Block up" (click)="moveUp(block)">
              <span>up</span>
            </a>
          </div>
          <div class="cms-control-button block-move-down" style="float: left;">
            <a title="Move this Block down" (click)="moveDown(block)">
              <span>down</span>
            </a>
          </div>
          <div class="cms-control-button block-delete">
            <span class="basic-icon delete-icon center-text"
              style="width: 23px; height: 23px; transform: translate(-50%, 23%);"
              (click)="deleteBlock(block)"></span>
          </div>
          <div class="cms-editable-element" (click)="editProductList(block)">
            <div>{{block?.stock_codes?"":"Product List"}}</div>
            <table class="product-table" style="width:96%;font-size: 11px;" cellspacing="0" cellpadding="0" border="0" *ngIf="block?.product_list?.length">
              <tbody>
                <tr class="product-row" *ngFor="let product of block?.product_list">
                  <td class="product-code">
                    <span>{{product?.stock_code}}</span>
                  </td>
                  <td class="product-desc" [class.error-desc]="product?.stk_valid=='0'">{{product?.stk_valid!='0'?product?.stk_description:'This is not a valid Stock Code. This line will not be published to customers'}}</td>
                  <td class="product-soh">{{product?.stk_available_qty}}</td>
                  <td class="product-price">{{product?.stk_current_price | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- cms-block-products end -->
        <div id="{{block.section_id}}" class="cms-block cms-block-comment1 cms-editable-area clearfix" *ngSwitchCase="'nl_comment'">
          <div class="cms-control-button block-move">
            <a title="Move this Block">
              <span>move</span>
            </a>
          </div>
          <div class="cms-control-button block-move-up" style="float: left;">
            <a title="Move this Block up" (click)="moveUp(block)">
              <span>up</span>
            </a>
          </div>
          <div class="cms-control-button block-move-down" style="float: left;">
            <a title="Move this Block down" (click)="moveDown(block)">
              <span>down</span>
            </a>
          </div>
          <div class="cms-control-button block-delete">
            <span class="basic-icon delete-icon center-text"
              style="width: 23px; height: 23px; transform: translate(-50%, 23%);"
              (click)="deleteBlock(block)"></span>
          </div>
          <p class="cms-editable-element" [class.block-content]="block?.content" (click)="editComment(block)">
            {{block?.content?block?.content:"Comment"}}
          </p>
        </div>
        <!-- cms-block-comment end -->
        <div id="{{block.section_id}}" class="cms-block cms-block-link1 cms-editable-area clearfix" *ngSwitchCase="'link'">
          <div class="cms-control-button block-move">
            <a title="Move this Block">
              <span>move</span>
            </a>
          </div>
          <div class="cms-control-button block-move-up" style="float: left;">
            <a title="Move this Block up" (click)="moveUp(block)">
              <span>up</span>
            </a>
          </div>
          <div class="cms-control-button block-move-down" style="float: left;">
            <a title="Move this Block down" (click)="moveDown(block)">
              <span>down</span>
            </a>
          </div>
          <div class="cms-control-button block-delete">
            <span class="basic-icon delete-icon center-text"
              style="width: 23px; height: 23px; transform: translate(-50%, 23%);"
              (click)="deleteBlock(block)"></span>
          </div>
          <p class="cms-editable-link" [class.block-content]="block?.link_url" (click)="editUrl(block)">
            {{block?.link_description?block?.link_description:"Link"}}
          </p>
        </div>
        <!-- cms-block-link end -->
      </div>
    </div>
  </div>